import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Slider from '@material-ui/core/Slider';
import { Popover, IconButton, Typography, CardContent} from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help';
import PopupState, { bindTrigger, bindPopover} from 'material-ui-popup-state'


class TableSlider extends Component{
    constructor(props){
        super(props)
        this.state = {
            answer: 0,
            answertext:'',
            answerarray: []
        }
    }
    
    componentDidMount(){
        var answerArray = this.props.question.Answers.sort((a,b) => a.AnswerSequenceInQuestion - b.AnswerSequenceInQuestion)
        //answerArray.unshift({"AnswerStandardContent": "Please select an answer"})
        if(this.props.question.Responses[0].Response != ''){
            for(var x=0; x<answerArray.length; x++){
                if(answerArray[x].AnswerId == this.props.question.Responses[0].Response){
                    this.setState({
                        answer: x,
                        answertext: answerArray[x].AnswerStandardContent,
                        answerarray: answerArray
                    })
                }
            }
        } else {
            this.setState({
                answer: 0,
                answertext: answerArray[0].AnswerStandardContent,
                answerarray: answerArray
            })
        }
    }

    handleChange = (ev, value) => {
       // if(ev.target.value != this.state.answer){
       //     this.setState({
       //         answer:ev.target.value
       //     })
       //     this.props.questionSetUpdateResponseValue(this.props.question.QuestionId, ev.target.value)
       // } 
       this.props.questionSetUpdateResponseValue(this.props.question.QuestionId, this.state.answerarray[value].AnswerId)
    }

    handleSliding = (ev, value) => {
        this.setState({
            answer: value,
            answertext: this.state.answerarray[value].AnswerStandardContent
        })
    }

    render(){
        if(this.props){
            let helpIcon = null
            if(this.props.question.QuestionHelpText.length){
                helpIcon = <PopupState variant="popover" popupId="help-popover">
                        {popupState => (
                            <span style={{float:'right', left:'-5px', width: '-1px', position:'relative', padding:'0', margin:'0'}}>

                            <IconButton aria-label="additional help text" variant="contained"  {...bindTrigger(popupState)} style={{color:'rgba(0,0,0,0.54)', padding:'2px', borderRadius:'50%'}}>
                                <HelpIcon style={{fontSize:'1.2rem'}}/>
                            </IconButton>
                            <Popover 
                                {...bindPopover(popupState)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'center',
                                    horizontal: 'right',
                                }}
                                >
                                <Typography style={{maxWidth:'330px', padding:'10px'}} dangerouslySetInnerHTML={{__html:this.props.question.QuestionHelpText}}></Typography>
                            </Popover>
                            </span>
                        )}
                    </PopupState>
            }
            return(
                //<Radio>Answer</Radio>
                <TableRow>
                    <TableCell>
                        {helpIcon}
                    </TableCell>
                    <TableCell scope="row" style={{paddingTop:"10px"}}>
                        {this.props.question.QuestionStandardContent}
                    </TableCell>
                    
                    <TableCell style={{width:"100%", paddingLeft:"10px"}}>
                        <Grid>
                            {this.state.answertext}
                        </Grid>
                        <Grid>
                            <Slider 
                            value={this.state.answer}
                            marks
                            step={1}
                            min={0}
                            max={this.props.question.Answers.length-1} 
                            onChange={this.handleSliding}
                            onChangeCommitted={this.handleChange}/> 
                        </Grid>
                       </TableCell>

                </TableRow>
            )
        } else return <p>nope</p> 
        
    }
}

export default TableSlider;